import zhCN from './zh_CN';

const map = {
  zh_CN: zhCN,
};

export const getTranslations = (translationLocale = '') => map?.[translationLocale] || map.zh_CN;
